export const vviinnLinkProps = {
  href: "https://www.vviinn.com/",
  target: "_blank",
  rel: "noreferrer",
  "aria-label": "vviinn website",
};
